import { c as _c } from "react/compiler-runtime";
import type { ArticlesSectionProps } from "./articles-section.types";
import { ListingCard } from "@/components/cards/listing-card/listing-card.component";
import { ListingCardContainer } from "@/components/cards/listing-card/listing-card-container.component";
export function ArticlesSection(t0) {
  const $ = _c(4);
  const {
    articles
  } = t0;
  if (articles.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== articles) {
    t1 = articles.map(_temp);
    $[0] = articles;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ListingCardContainer columns={3}>{t1}</ListingCardContainer>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(article) {
  return <ListingCard key={article.id} variant="article" visual={article.visual} title={article.title} href={article.href} categories={article.categories ?? []} date={article.date} />;
}